<template>
	<div class="pb-5">
		<div class="mt-2 mb-3 container-header">
			<div class="container-body-header">
				<div class="d-flex align-items-center">
					<p class="page-btn" :class="[pageActive == 1 ? 'disabled' : null]" @click="changePage(pageIn - 1)">
						<feather-icon icon="ChevronLeftIcon" size="20" />
					</p>
					<div class="container-btns">
						<p
							@click="changePage(num)"
							class="page-btn"
							:class="[pageActive == num ? 'active' : null]"
							v-for="(num, index) in pages"
							:key="index"
						>
							{{ num }}
						</p>
					</div>
					<p
						class="page-btn"
						:class="[pageActive == totalPages ? 'disabled' : null]"
						@click="changePage(pageIn + 1)"
					>
						<feather-icon icon="ChevronRightIcon" size="20" />
					</p>
				</div>
				<div class="d-flex align-items-center justify-content-center mt-2 mt-md-0">
					<b-form-input
						type="text"
						class="form-control"
						placeholder="Buscar participante"
						v-model="search"
						debounce="1000"
						@keyup.enter="searchData()"
					/>
					<div class="d-flex align-items-center justify-content-end ml-2">
						<add-participant @refresh="init" />
					</div>
				</div>
			</div>
		</div>
		<b-card no-body>
			<b-table-simple sticky-header="60vh">
				<b-thead class="text-center">
					<b-th>#</b-th>
					<b-th class="cursor-pointer" @click="sortBy('participant_name')">
						Nombre
						<feather-icon
							:icon="
								sortKey === 'participant_name' && sortOrder === 'asc'
									? 'ChevronUpIcon'
									: 'ChevronDownIcon'
							"
							size="16"
						/>
					</b-th>
					<b-th class="cursor-pointer" @click="sortBy('confrontation_counter')">
						Peleas
						<feather-icon
							:icon="
								sortKey === 'confrontation_counter' && sortOrder === 'asc'
									? 'ChevronUpIcon'
									: 'ChevronDownIcon'
							"
							size="16"
						/>
					</b-th>
					<b-th>Creado por</b-th>
					<b-th>Opciones</b-th>
				</b-thead>
				<b-tbody class="text-center">
					<b-tr v-if="isLoading">
						<b-td colspan="5" class="text-center">
							<feather-icon icon="LoaderIcon" size="24" class="text-primary" />
							Cargando participantes...
						</b-td>
					</b-tr>
					<template v-else>
						<b-tr v-for="(item, index) in data" :key="index">
							<b-td>
								{{ index + 1 }}
							</b-td>

							<b-td>
								{{ item.participant_name }}
							</b-td>

							<b-td
								@click="item.confrontation_counter ? openDetailModal(item) : null"
								:class="{ 'underline-hover': item.confrontation_counter }"
							>
								{{ item.confrontation_counter || 0 }}
							</b-td>

							<b-td>
								<div>
									{{ item.created_user.user }}
								</div>
								<div>{{ item.created_user.date | myGlobalDay }}</div>
							</b-td>
							<b-td class="d-flex justify-content-center">
								<edit-participant :participant="item" @refresh="init" />
								<feather-icon
									@click="deleteParticipant(item)"
									class="icon text-danger ml-1"
									icon="TrashIcon"
									:size="width < 600 ? '18' : '24'"
								/>
							</b-td>
						</b-tr>
					</template>
				</b-tbody>
			</b-table-simple>
		</b-card>
		<ParticipantSelect
			v-if="showParticipantSelect"
			@close="showParticipantSelect = false"
			:toRemove="selectedParticipant"
			@refresh="init"
		/>
		<ConfrontationsByRivalModal
			v-if="showConfrontationsModal"
			:rival="rivalSelected"
			@closing="showConfrontationsModal = false"
		/>
	</div>
</template>

<script>
import participantService from "./participants.service"
import vSelect from "vue-select"
import AddParticipant from "./components/AddParticipant.vue"
import EditParticipant from "./components/EditParticipant.vue"
import ParticipantSelect from "./components/ParticipantSelect.vue"
import * as _ from "lodash"
import ConfrontationsByRivalModal from "@/views/brain/tournament/views/participants/components/ConfrontationsByRivalModal.vue"
export default {
	name: "ListParticipantsBrain",
	components: { vSelect, AddParticipant, EditParticipant, ParticipantSelect, ConfrontationsByRivalModal },
	data() {
		return {
			showParticipantSelect: false,
			data: [],
			width: this.$store.state["app"].windowWidth,
			pageIn: 1,
			perPageIn: 50,
			search: null,
			pages: [],
			pageActive: 1,
			totalPages: null,
			showConfrontationsModal: false,
			selectedParticipant: null,
			sortKey: "confrontation_counter",
			sortOrder: "desc",
			isLoading: true,
		}
	},
	computed: {},
	mounted() {
		this.init()
	},
	methods: {
		sortBy(key) {
			if (this.sortKey === key) {
				this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc"
			} else {
				this.sortKey = key
				this.sortOrder = key === "confrontation_counter" ? "desc" : "asc"
			}
			this.init()
		},
		openDetailModal(rival) {
			this.rivalSelected = {
				id: rival.id,
				name: rival.participant_name,
			}
			this.showConfrontationsModal = true
		},
		openParticipantSelect(item) {
			this.showParticipantSelect = true
			this.selectedParticipant = item
		},
		async init() {
			this.isLoading = true
			const {
				data: { data, last_page, current_page },
			} = await participantService.getContactsToStatus({
				status: 0,
				search: this.search,
				pageIn: this.pageIn,
				perPageIn: this.perPageIn,
				type_id: 1,
				orderby: this.sortKey,
				order: this.sortOrder,
			})
			this.pages = this.createPages(last_page)
			this.pageActive = current_page
			this.totalPages = last_page
			this.data = data.map((item) => {
				return {
					...item,
					created_user: JSON.parse(item.created_user),
				}
			})
			this.isLoading = false
		},
		searchData() {
			this.pageIn = 1
			this.init()
		},
		createPages(num) {
			let pages = []
			for (let i = 1; i <= num; i++) {
				pages.push(i)
			}
			return pages
		},
		changePage(page) {
			if (page >= 1 && page <= this.totalPages) {
				this.pageIn = page
				this.init()
			}
		},
		async deleteParticipant(item) {
			const swal = await this.showConfirmSwal()
			if (swal.isConfirmed) {
				try {
					const resp = await participantService.deleteParticipantById({
						user_id: this.currentUser.user_id,
						id: item.id,
						type: 1,
					})

					this.data = this.data.filter((participant) => item.id !== participant.id)
				} catch (error) {
					this.openParticipantSelect(item)
				}
			}
		},
	},
	watch: {
		search(newValue, oldValue) {
			this.searchData()
		},
	},
}
</script>

<style lang="scss" scoped>
.underline-hover {
	text-decoration: underline;
	transition: all 0.1s ease;
}
.underline-hover:hover {
	font-weight: bold;
	cursor: pointer;
	font-size: 1.2rem;
}
.container-header {
	background: #fff;
	padding: 1rem;
	border-radius: 10px;
	box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
	transition: 0.1s all ease-in-out;
	@media screen and (min-width: 700px) {
		padding: 1rem;
	}
	.page-btn {
		height: 32px;
		width: 32px;
		margin: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: 0.3s all ease-in-out;
		border-radius: 32px;
		cursor: pointer;
		background: #f3f2f7;
	}
	.container-btns {
		margin: 0 0.4rem;
		width: auto;
		background: #f3f2f7;
		height: 32px;
		border-radius: 16px;
		display: flex;
		align-items: center;
		transition: 0.1s all ease-in-out;
		.active {
			background: var(--primary);
			color: #fff;
		}
	}
	.disabled {
		color: #d5d5d5;
	}
}
.dark-layout {
	.container-header {
		background: #283046;
		.page-btn {
			background: #242b3d;
		}
		.container-btns {
			background: #242b3d;
			.active {
				background: var(--primary);
				color: #fff;
			}
		}
	}
}
.content-table {
	min-width: 100%;
	background: #fff;

	border-radius: 10px;
	overflow-x: scroll;
	overflow-y: visible;
	@media screen and (min-width: 1000px) {
		overflow-x: visible;
		overflow-y: visible;
	}
	.container-table-coliseum {
		min-width: 800px;
		padding: 0.5rem 1rem;
		display: grid;
		grid-template-columns: 1fr 4fr 4fr 4fr;
		text-align: center;
		@media screen and (min-width: 600px) {
			padding: 1rem 2rem;
		}

		p {
			margin: 0;
			font-size: 12px;
			transition: 0.1s all ease-in-out;
			@media screen and (min-width: 600px) {
				font-size: 14px;
			}
		}
		.icon {
			//color: red;
			margin: 0 0.2rem;
			cursor: pointer;
		}
	}
	.header-table {
		transition: 0.1s all ease-in-out;
		background: #f3f2f7;
		text-align: center;
		p {
			font-weight: 600;
		}
	}
	.body-table {
		border-bottom: 0.5px solid #e6e6e6;
		transition: 0.1s all ease-in-out;
		&:last-child {
			border-bottom: none;
		}
		.body-index {
			min-width: 30.88px;
		}
		.body-cell {
			min-width: 123.52px;
			p {
				word-wrap: break-word;
			}
			.badge {
				width: 80%;
				@media screen and (min-width: 600px) {
					width: 50% !important;
				}
			}
		}
	}
}
.dark-layout {
	.content-table {
		background: #283046;
		.header-table {
			background: #343d55;
		}
		.body-table {
			border-bottom-color: #3b4253;
		}
	}
}
.container-body-header {
	display: flex;
	flex-direction: column;
	@media screen and (min-width: 700px) {
		flex-direction: row;
		justify-content: space-between;
	}
}
</style>
